/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect} from 'react'
import {useMutation, useQueryClient} from 'react-query'
import {MenuComponent} from '../../../../../../_dashboard/assets/ts/components'
import {ID, KTSVG} from '../../../../../../_dashboard/helpers'
import {useListView} from '../../core/ListViewProvider'
import {useQueryResponse} from '../../core/QueryResponseProvider'
import { deleteOne } from '../../../../../services/common_requests'
import { useIntl } from 'react-intl'
import {toast} from 'react-toastify'
import dataAxios from '../../../../../modules/auth/core/dataAxios'

type Props = {
  id: ID
  reservation?: any
}
const ReservationActionsCell: FC<Props> = ({id, reservation}) => {
  const intl = useIntl();
  const {setItemIdForUpdate} = useListView()
  const {refetchData} = useQueryResponse()

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const openEditModal = () => {
    setItemIdForUpdate(id)
  }

  const deleteItem = useMutation(() => deleteOne(id,'/'), {
    onSuccess: () => {
      refetchData()
    },
  })

  const isExternalReservationValidated = reservation?.externalApiStatus === 'confirmed' || !!reservation?.bookingId
  const hasVoucherData = !!(reservation?.downloadVoucherLink || reservation?.voucherUrl || reservation?.voucherNum || reservation?.bookingId)
  const hasVoucher = isExternalReservationValidated && hasVoucherData
  const apiBase = process.env.REACT_APP_API_URL || ''
  const imageBase = process.env.REACT_APP_API_URL_IMAGE || apiBase

  const getDirectVoucherHref = () => {
    if (reservation?.downloadVoucherLink) return `${imageBase}${reservation.downloadVoucherLink}`
    if (reservation?.voucherUrl) return reservation.voucherUrl
    return null
  }

  const directVoucherHref = getDirectVoucherHref()
  const needsGuardedDownload = !directVoucherHref && !!id

  const handleVoucherDownload = async (e?: React.MouseEvent) => {
    if (e) e.preventDefault()
    const direct = getDirectVoucherHref()
    if (direct) {
      window.open(direct, '_blank', 'noopener,noreferrer')
      return
    }
    if (!id) return
    const href = `${apiBase}/reservations/${id}/voucher`
    try {
      const resp = await dataAxios.get(href, { responseType: 'blob' })
      const blob = resp.data as Blob
      const objectUrl = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = objectUrl
      const filename = `voucher-${reservation?.orderNumber || id}.pdf`
      a.download = filename
      document.body.appendChild(a)
      a.click()
      a.remove()
      window.URL.revokeObjectURL(objectUrl)
    } catch (err: any) {
      if (err?.response?.status === 401 || err?.response?.status === 403) {
        toast.error(intl.formatMessage({ id: 'ERROR.UNAUTHORIZED', defaultMessage: 'Unauthorized' }))
      } else {
        toast.error(err?.message || 'Download failed')
      }
    }
  }

  return (
    <>
      <a
        href='#'
        className='btn btn-transparent btn-active-light-transparent btn-sm'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
      >
  
        <KTSVG path='/media/icons/duotune/arrows/Threedots.svg' className='svg-icon-5 m-0' />
      </a>
      {/* begin::Menu */}
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-1'
        data-kt-menu='true'
      >
        {/* begin::Menu item */}
        <div className='menu-item px-3'>
          <a className='menu-link px-3'  href={`/reservation/${id}`}>
          {intl.formatMessage({ id: 'ACTION.DETAILS' })}
          </a>
        </div>
        {/* end::Menu item */}

        {/* Voucher download (smart: direct link or authenticated blob to avoid 401) */}
        {hasVoucher && (directVoucherHref || needsGuardedDownload) && (
          <div className='menu-item px-3'>
            <a
              className='menu-link px-3'
              href={directVoucherHref || '#'}
              onClick={directVoucherHref ? undefined : handleVoucherDownload}
              target={directVoucherHref ? '_blank' : undefined}
              rel={directVoucherHref ? 'noopener noreferrer' : undefined}
            >
              {intl.formatMessage({ id: 'COMMON.DOWNLOAD_VOUCHER', defaultMessage: 'Download Voucher' })}
            </a>
          </div>
        )}

        {/* begin::Menu item */}
    
        {/* end::Menu item */}
      </div>
      {/* end::Menu */}
    </>
  )
}

export {ReservationActionsCell}
